import City from '../../models/common/city.model';
import Degree from '../../models/common/degree.model';
import Diversity from '../../models/common/diversity.model';
import ExperienceTime from '../../models/common/experience-time.model';
import HireType from '../../models/common/hire-type.model';
import ProfessionalMoment from '../../models/common/professional-moment.model';
import Proficiency from '../../models/common/proficiency.model';
import { SignUpReasonInterface } from '../../models/common/sign-up-reason.model';
import Skill from '../../models/common/skill.model';
import { StorageRequiredData } from './../storage-data';

export interface CommonState {
    experienceTimeData: StorageRequiredData<ExperienceTime[], any>;
    diversityData: StorageRequiredData<Diversity[], any>;
    proficiencyData: StorageRequiredData<Proficiency[], any>;
    hireTypeData: StorageRequiredData<HireType[], any>;
    degreeData: StorageRequiredData<Degree[], any>;
    professionalMomentData: StorageRequiredData<ProfessionalMoment[], any>;
    skillData: StorageRequiredData<Skill[], any>;
    cityData: StorageRequiredData<City[], any | null>;
    signupReasons: StorageRequiredData<SignUpReasonInterface[], any>;
}

const DEFAULT_INITIAL_DATA = {
    data: [],
    loading: false,
    error: null
}

export const INITIAL_STATE: CommonState = {
    experienceTimeData: DEFAULT_INITIAL_DATA,
    diversityData: DEFAULT_INITIAL_DATA,
    proficiencyData: DEFAULT_INITIAL_DATA,
    hireTypeData: DEFAULT_INITIAL_DATA,
    degreeData: DEFAULT_INITIAL_DATA,
    professionalMomentData: DEFAULT_INITIAL_DATA,
    skillData: DEFAULT_INITIAL_DATA,
    cityData: DEFAULT_INITIAL_DATA,
    signupReasons: DEFAULT_INITIAL_DATA,
};

export enum CommonActionTypes {
    FETCH_EXPERIENCE_TIME = '@common/FETCH_EXPERIENCE_TIME',
    FETCH_EXPERIENCE_TIME_SUCCESS = '@common/FETCH_EXPERIENCE_TIME_SUCCESS',
    FETCH_EXPERIENCE_TIME_ERROR = '@common/FETCH_EXPERIENCE_TIME_ERROR',

    FETCH_DIVERSITY = '@common/FETCH_DIVERSITY',
    FETCH_DIVERSITY_SUCCESS = '@common/FETCH_DIVERSITY_SUCCESS',
    FETCH_DIVERSITY_ERROR = '@common/FETCH_DIVERSITY_ERROR',

    FETCH_PROFICIENCY = '@common/FETCH_PROFICIENCY',
    FETCH_PROFICIENCY_SUCCESS = '@common/FETCH_PROFICIENCY_SUCCESS',
    FETCH_PROFICIENCY_ERROR = '@common/FETCH_PROFICIENCY_ERROR',

    FETCH_HIRE_TYPE = '@common/FETCH_HIRE_TYPE',
    FETCH_HIRE_TYPE_SUCCESS = '@common/FETCH_HIRE_TYPE_SUCCESS',
    FETCH_HIRE_TYPE_ERROR = '@common/FETCH_HIRE_TYPE_ERROR',

    FETCH_DEGREE = '@common/FETCH_DEGREE',
    FETCH_DEGREE_SUCCESS = '@common/FETCH_DEGREE_SUCCESS',
    FETCH_DEGREE_ERROR = '@common/FETCH_DEGREE_ERROR',

    FETCH_PROFESSIONAL_MOMENT = '@common/FETCH_PROFESSIONAL_MOMENT',
    FETCH_PROFESSIONAL_MOMENT_SUCCESS = '@common/FETCH_PROFESSIONAL_MOMENT_SUCCESS',
    FETCH_PROFESSIONAL_MOMENT_ERROR = '@common/FETCH_PROFESSIONAL_MOMENT_ERROR',

    FETCH_SKILL = '@common/FETCH_SKILL',
    FETCH_SKILL_SUCCESS = '@common/FETCH_SKILL_SUCCESS',
    FETCH_SKILL_ERROR = '@common/FETCH_SKILL_ERROR',

    FETCH_CITY_DATA = '@common/FETCH_CITY_DATA',
    FETCH_CITY_DATA_SUCCESS = '@common/FETCH_CITY_DATA_SUCCESS',
    FETCH_CITY_DATA_ERROR = '@common/FETCH_CITY_DATA_ERROR',

    FETCH_SIGNUP_REASONS = '@common/FETCH_SIGNUP_REASONS',
    FETCH_SIGNUP_REASONS_SUCCESS = '@common/FETCH_SIGNUP_REASONS_SUCCESS',
    FETCH_SIGNUP_REASONS_ERROR = '@common/FETCH_SIGNUP_REASONS_ERROR',
}
